/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Product } from '../storage';
import { SortingOptions, SORTING_OPTIONS } from '../../../util/consts';

export const sortProducts = (data: Product[], sortBy: SortingOptions) => {
  const sortByIndex = SORTING_OPTIONS.findIndex((option) => option === sortBy);
  switch (sortByIndex) {
    case 0: //sort by Most recently ordered
      return data.slice(0).sort((a, b) => {
        const aOrders = a.orders;
        const bOrders = b.orders;
        const aLastOrderDate = new Date(
          Math.max(...aOrders.map((x) => new Date(x.createdAt).getTime())),
        );
        const bLastOrderDate = new Date(
          Math.max(...bOrders.map((x) => new Date(x.createdAt).getTime())),
        );
        return bLastOrderDate.getTime() - aLastOrderDate.getTime();
      });
    case 1: //sort by Most ordered
      return data.slice(0).sort((a, b) => {
        const aTotal = a.orders
          .map((x) => x.quantity)
          .reduce((accumulator, current) => accumulator + current, 0);
        const bTotal = b.orders
          .map((x) => x.quantity)
          .reduce((accumulator, current) => accumulator + current, 0);
        return bTotal - aTotal;
      });
    case 2: //sort by Price (High to Low)
      return data.slice(0).sort((a, b) => b.discountedPriceExcGst - a.discountedPriceExcGst);
    case 3: //sort by Price (Low to High)
      return data.slice(0).sort((a, b) => a.discountedPriceExcGst - b.discountedPriceExcGst);
    case 4: //sort by Alphabetical (A-Z)
      return data.slice(0).sort((a, b) => a.description.localeCompare(b.description));
    default:
      return data.slice(0);
  }
};
